module.exports = __webpack_public_path__ + "static/media/holdSpacebar.edbb30a9.mp4";